import useGlobalSearchURLHashVertical from 'hooks/GlobalSearch/useGlobalSearchURLHashVertical'
import { useCallback, useEffect, useState } from 'react'
import lazyImport from 'components/utils/lazyImport'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'

// Content pulls every search vertical hook (flights/cruises/car-hire/...). Keep it
// out of the initial Routes/app graph until the user opens search at least once.
const GlobalSearchV2Content = lazyImport(
  () => import('./GlobalSearchV2Content'),
  <LoadingIndicator visible floating />,
)

/** Warm the V2 search chunk on hover/focus so first open is less likely to flash a loader. */
export function preloadGlobalSearchV2Content() {
  GlobalSearchV2Content.load()
    .catch(error => {
      return import('services/errorReportingService').then(({ reportClientMessage }) =>
        reportClientMessage(
          'global_search_v2_content_preload_failed',
          { errorMessage: error instanceof Error ? error.message : String(error) },
          'warning',
        ))
    })
    .catch(() => undefined)
}

function GlobalSearchV2() {
  // Rendering all the tabs can be quite expensive on first load and the user may not ever interact with us
  // so track our first open and hide it until we've been opened at least once
  const { openedSearchVertical, toggleSearchVertical } = useGlobalSearchURLHashVertical()
  const [hasSearchOpened, setSearchHasOpened] = useState<boolean>(!!openedSearchVertical)

  const closeSearch = useCallback(() => { toggleSearchVertical('none') }, [toggleSearchVertical])

  useEffect(() => {
    if (openedSearchVertical) {
      setSearchHasOpened(true)
    }
  }, [openedSearchVertical])

  if (!hasSearchOpened) {
    return null
  }

  return <GlobalSearchV2Content
    openedSearchVertical={openedSearchVertical}
    onClose={closeSearch}
  />
}

export default GlobalSearchV2
